define('Components/MediaWidget/js/views/MediaWidgetInstanceView',['jquery','app','WidgetInstanceView',
    'LazyLoad',
    'template!Components/MediaWidget/templates/default',
    'template!Components/MediaWidget/templates/home',
    'template!Components/MediaWidget/templates/interactive-1',
    'objectFitPolyfill','modernizr'],
    function($,app,WidgetInstanceView,
             LazyLoad,
             defaultTemplate, homeTemplate, interactive1Template){
    return WidgetInstanceView.extend({
        name:'MediaWidgetInstanceView',
        events: {
            'click .expand':'expand',
            'click .btn-play':'playVideo',
        },
        getTemplate:function(){
            switch(this.model.getTemplate()){

                case 'home':  return homeTemplate; break;
                case 'interactive-1':  return interactive1Template; break;
                case 'default': default: return defaultTemplate; break;

            }
        },
        expand: function(e){
            this.$('.media-widget').addClass('video-inactive');
        },
        afterRender:function(){
            var self = this;
            self.listenTo(app,'change:scrollTop',self.onScroll);
            if(!Modernizr.objectfit){
                objectFitPolyfill();
            }
            LazyLoad(self.$('.lazyload'));
        },
        playVideo:function(){
            // seulement sur mobile
            var view = this,video = view.$('video').get(0);
            if(video){
                view.$('.frame').append(video);
                video.play();
            }

        },
        onScroll: function(){
            var sel = this.$('.left-centered>div');
            if(!sel.hasClass('active') && sel.get(0)) {
                if (app.get('scrollTop') > sel.offset().top - app.get('winH') + sel.height()) {
                    sel.addClass('active');
                }
            }
        }
    })
});
